import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import MobileDocumentSearch from '@/views/PrivateRoutes/Dashboard/Documents/MobileDocumentSearch';
import Box from '../atomic/Box';
import RoomList from '../RoomList';
import Page from '../layouts/WithHeader';
import EmptyMessage from '../EmptyMessage';
import useDesktop from '../../hooks/useDesktop';
import ErrorContainer from '../ErrorContainer';
import { getFilteredRooms } from '../../utils/rooms';
import { acSetShowAddRoom } from '../../store/actions/rooms';
import { acSetDocumentSearchText } from '../../store/actions/documents';
import { sGetDocumentSearchText } from '../../store/reducers/documents';

const RoomsPage = ({
  rooms,
  fetching,
  fetchingError,
  publicSection = false,
  emptyMessage = 'Du har ikke opprettet noen rom',
  setShowAddRoom,
  searchText,
  setSearchText,
}) => {
  const isDesktop = useDesktop();

  const [searchQuery, setSearchQuery] = useState('');

  const filteredRooms = getFilteredRooms(rooms, searchQuery);

  const onAddRoom = () => {
    setShowAddRoom(true);
  };

  const onSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const mobileHeaderSearch = () => (
    <MobileDocumentSearch
      fullWidth
      value={searchText}
      onChange={onSearchChange}
      placeholder="Søk etter rom"
      isSearching
      setIsSearching={() => null}
      onClearSearch={() => setSearchText('')}
    />
  );

  useEffect(() => setSearchQuery(searchText), [searchText]);

  useEffect(() => {
    setSearchText('');
  }, []);

  const renderContent = () => {
    if (fetchingError) {
      return (
        <ErrorContainer
          paddingTop={isDesktop}
          errorResponse={fetchingError}
          style={{ paddingTop: isDesktop ? undefined : '15%' }}
        />
      );
    }

    if (!fetching && Array.isArray(rooms) && rooms.length === 0) {
      return (
        <EmptyMessage publicSection={publicSection} onLinkClick={onAddRoom}>
          {emptyMessage}
        </EmptyMessage>
      );
    }

    return (
      <>
        <Box mt={4}>
          <RoomList
            fetching={fetching}
            rooms={filteredRooms}
            searchQuery={searchQuery}
            enableImageUpload={!publicSection}
          />
        </Box>
      </>
    );
  };

  return (
    <Page
      topLevelLayout
      headerTitle="Rom"
      maxWidth="xl"
      publicSection={publicSection}
      headerSearch={mobileHeaderSearch()}
    >
      {renderContent()}
    </Page>
  );
};

const mapStateToProps = (state) => ({
  searchText: sGetDocumentSearchText(state),
});

const mapDispatchToProps = (dispatch) => ({
  setShowAddRoom: (payload) => dispatch(acSetShowAddRoom(payload)),
  setSearchText: (searchText) => dispatch(acSetDocumentSearchText(searchText)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RoomsPage);
